<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    totalArticlesDone?: number
    totalChildren?: number
    chapterStatus: ChapterStatus
  }>(),
  {
    totalArticlesDone: 0,
    totalChildren: 0,
  },
)

const totalArticlesDoneSetMaxLimit = ref(props.totalArticlesDone)
watch(
  () => props.totalArticlesDone,
  (newValue) => {
    if (props.totalArticlesDone > props.totalChildren) {
      totalArticlesDoneSetMaxLimit.value = props.totalChildren
    } else {
      totalArticlesDoneSetMaxLimit.value = newValue
    }
  },
  { immediate: true },
)

type ChapterStatus = "not-started" | "in-progress" | "done"
type ChapterStatusIcon =
  | "circle-hollow"
  | "circle-filled-half"
  | "circle-filled"

function mapIcons(status: ChapterStatus): ChapterStatusIcon {
  switch (status) {
    case "not-started":
      return "circle-hollow"
    case "in-progress":
      return "circle-filled-half"
    case "done":
      return "circle-filled"
  }
}
</script>

<template>
  <div
    class="rounded-full px-2 text-base text-white opacity-75 group-hover:opacity-100"
  >
    <div class="flex items-center gap-2">
      <div>
        {{ totalArticlesDoneSetMaxLimit }}/{{ props.totalChildren }}
      </div>
      <UIcon
        :name="mapIcons(chapterStatus)"
        size="xs"
        :aria-label="`Artikler ${props.chapterStatus}`"
      />
    </div>
  </div>
</template>
